import { render, staticRenderFns } from "./SpecialIssues.vue?vue&type=template&id=e2d3f458&scoped=true"
import script from "./SpecialIssues.vue?vue&type=script&lang=js"
export * from "./SpecialIssues.vue?vue&type=script&lang=js"
import style0 from "./SpecialIssues.vue?vue&type=style&index=0&id=e2d3f458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d3f458",
  null
  
)

export default component.exports